import { render, staticRenderFns } from "./rechargePage.vue?vue&type=template&id=42ebb953&scoped=true&"
import script from "./rechargePage.vue?vue&type=script&lang=js&"
export * from "./rechargePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ebb953",
  null
  
)

export default component.exports